/* Brzo dodaj u korpi ("Možda će ti se dopasti"): klik na veličinu dodaje proizvod i osvežava korpu. */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-elia-upsell-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const drawer = document.querySelector('cart-drawer');
  const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
  const group = btn.closest('.elia-cart-upsell-sizes');
  group?.querySelectorAll('button').forEach((b) => (b.disabled = true));
  btn.setAttribute('aria-busy', 'true');
  try {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.eliaUpsellAdd), quantity: 1 }], sections, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'error');
    if (drawer && drawer.renderContents) {
      drawer.renderContents({ id: data.items?.[0]?.product_id, sections: data.sections });
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  } catch (err) {
    btn.removeAttribute('aria-busy');
    group?.querySelectorAll('button').forEach((b) => (b.disabled = b.hasAttribute('data-soldout')));
    let msg = group?.parentElement.querySelector('.elia-cart-upsell-error');
    if (!msg && group) { msg = document.createElement('p'); msg.className = 'elia-cart-upsell-error'; msg.setAttribute('role', 'alert'); group.after(msg); }
    if (msg) msg.textContent = 'Nije dodato. Pokušaj ponovo.';
  }
});
